<!-- 轮播广告 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">动画设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <FormItem label="长宽比例">
                            <Select v-model="newFormData.content.height_id" clearable filterable placeholder="请输入长宽比例">
                                <Option v-for="item in heightList" :value="item.id" :key="item.id" >{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="轮播图">
                            <div class="add-div">
                                <img class="add-icon" src="@/assets/homeset/plus.png" @click="addBanner"/>
                                <div class="add-txt" @click="addBanner">添加</div>
                            </div>
                        </FormItem>
                        <div v-for="(item, index) of newFormData.content.bannerList" :key="index">
                            <div class="view1">
                                <div class="banner-box" @click="openModal(index)">
                                    <img class="del-icon-style" src="@/assets/homeset/del.png" @click.stop="delBanner(index)"/>
                                    <img v-if="item.picview" :src="item.picview"/>
                                    <Icon class="absolute-icon" type="md-add"/>
                                </div>
                                <div>
                                    <Select class="mb-6" v-model="item.action_id" filterable placeholder="跳转动作">
                                        <Option v-for="item in actionList" :value="item.id" :key="item.id" >{{ item.name }}</Option>
                                    </Select>
                                    <Input v-if="item.action_id == 1" v-model="item.link_name" placeholder="请输入外部链接"></Input>
                                    <Select v-if="item.action_id == 2" v-model="item.link_id" filterable placeholder="跳转链接">
                                        <Option v-for="item in linkList" :value="item.id" :key="item.id" >{{ item.title }}</Option>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <div class="form-title">轮播图方式</div>
                        <FormItem label="轮播方式">
                            <RadioGroup v-model="newFormData.content.autoplay">
                                <Radio class="mr-24" label="1">自动播放</Radio>
                                <Radio class="mr-24" label="0">手动播放</Radio>
                            </RadioGroup>
                        </FormItem>
                        <div class="form-title">轮播图静止时间</div>
                        <FormItem label="静止时间">
                            <Slider class="w300" v-model="newFormData.content.time"></Slider>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 3">
                    <Form :model="newFormData" label-position="right" :label-width="80">
                        <div class="form-title">组件间距</div>
                        <FormItem label="上下间距"><Slider class="w300" v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider class="w300" v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider class="w300" v-model=" newFormData.content.marginData.topRadius"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider class="w300" v-model=" newFormData.content.marginData.bottomRadius"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        newFormData: {
            type: Object,
            default: {},
        },
        linkList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            srctype: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            actionList: [],
            heightList: [
                { id: 1, name: "1：1" },
                { id: 2, name: "2：1" },
                { id: 3, name: "4：3" },
                { id: 4, name: "3：4" },
                { id: 5, name: "1：2" },
            ],
        };
    },
    mounted() {
        if (this.diy_id == 1) {
            this.actionList = [
                { id: 1, name: "跳转外部链接" },
                { id: 2, name: "跳转页面" },
                { id: 3, name: "扫一扫" },
            ];
        } else {
            this.actionList = [
                { id: 1, name: "跳转外部链接" },
                { id: 3, name: "扫一扫" },
            ];
        }
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bannerList[this.srctype].picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bannerList[this.srctype].value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
            this.srctype = index;
        },
        selectName(name) {
            this.name_id = name;
        },
        // 删除轮播
        delBanner(e) {
            if (this.newFormData.content.bannerList.length == 1) {
                this.$Message.info("至少保留一张");
            } else {
                this.newFormData.content.bannerList.splice(e, 1);
            }
        },
        // 添加轮播图
        addBanner() {
            this.newFormData.content.bannerList.push({
                value: "/img/diy/banner.png",
                picview: "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                action_id: 1, link_id: 1, link_name: "",
            });
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.add-div {
    float: right;
    display: flex;
    align-items: center;
}
.add-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.banner-box {
    margin: 12px 0;
    width: 100%;
    height: 130px;
    display: flex;
    justify-content: center;
    position: relative;
    border: 1px solid #c0c4cc;
}
.banner-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.del-icon-style {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 99;
    width: 26px !important;
    height: 26px !important;
    cursor: pointer;
}
.absolute-icon {
    position: absolute;
    font-size: 50px;
    cursor: pointer;
    color: #c0c4cc;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}
.add-txt {
    font-size: 14px;
    color: #ff761d;
    cursor: pointer;
}
.view1 {
    padding: 12px; 
    margin-bottom: 12px;
    border: 1px solid #c0c4cc; 
}
.mb-6 {
    margin: 0 0 6px 0;
}
</style>